export default __webpack_public_path__ + "static/media/rebrand-square-logo-red.61039d52.svg";